import { useId } from 'react'
import { Field, Select as DsSelect, type SelectOption } from 'admination-react'
import type { FieldHint } from './FormRenderer'

export function Select({
  options,
  value,
  onChange,
  placeholder = '—',
  compact = false,
  invalid = false,
  required = false,
  icon,
  readOnly = false,
  ariaLabel,
  id,
}: {
  options: SelectOption[]
  value: string
  onChange: (v: string) => void
  placeholder?: string
  compact?: boolean
  invalid?: boolean
  required?: boolean
  icon?: string
  readOnly?: boolean
  ariaLabel?: string
  id?: string
}) {
  return (
    <DsSelect
      id={id}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      compact={compact}
      readOnly={readOnly}
      icon={icon}
      aria-invalid={invalid || undefined}
      aria-required={required || undefined}
      aria-label={ariaLabel}
    />
  )
}

export function SelectField({
  label,
  options,
  value,
  onChange,
  invalid = false,
  errorMessage,
  hint,
  optionLabel,
  required = false,
  readOnly = false,
  placeholder = '—',
}: {
  label: string
  options: string[]
  value: string
  onChange: (v: string) => void
  invalid?: boolean
  errorMessage?: string
  hint?: FieldHint
  optionLabel?: (option: string) => string
  required?: boolean
  readOnly?: boolean
  placeholder?: string
}) {
  const optList: SelectOption[] = [
    ...(required ? [] : [{ value: '', label: '—' }]),
    ...options.map((o) => ({ value: o, label: optionLabel ? optionLabel(o) : o })),
  ]
  const id = useId()
  return (
    <Field
      label={label}
      htmlFor={id}
      required={required}
      error={errorMessage}
      hint={hint?.text}
      hintTone={hint?.tone}
    >
      <Select
        id={id}
        options={optList}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        invalid={invalid}
        required={required}
        readOnly={readOnly}
      />
    </Field>
  )
}
